import {
  type FinisherCertificate,
  type FullSubEvent,
  type SubEventSegment,
  ResultType,
} from '@fastnorth/timer-api';
import type { ResultDetail } from '../../../../../../graphql/rest-link/types.ts';
import { RaceStatus } from '../../../../../../config/types.ts';

const SAMPLE_SEGMENT = {
  id: 'seg-1',
  type: { key: 'split', label: 'Split', id: 1, isTransition: false, isChallenge: false },
  name: 'Split 1',
  distance: 5,
  distanceUnit: 'km',
  cumulativeDistance: 5,
  cumulativeDistanceUnit: 'km',
  calculatePaceBy: 'km',
  calculateCumulativePaceBy: 'km',
  order: 1,
  segmentUuid: 'seg-uuid-1',
  resultSubEventId: 0,
  uuid: 'seg-uuid-1',
  isHidden: false,
} as unknown as SubEventSegment;

export const DEFAULT_RESULT_DETAILS: ResultDetail = {
  __typename: 'ResultDetail',
  awards: [
    {
      awardId: 1,
      label: 'Overall',
      placeOrdinal: '1st',
      subEventResults: { columns: [], flattenedColumns: [], results: [], subEventIds: [] },
    },
  ],
  gunTime: undefined,
  id: '',
  isActivitiesEditable: false,
  medals: [],
  menu: [],
  overallPlace: undefined,
  participant: {
    id: null,
    displayNameInitials: 'CS',
    displayName: 'Casey Smith',
    name: 'Casey Smith',
    fromLocation: 'Toronto, Canada',
    subEventName: 'Half Marathon',
    bib: '127',
    team: 'Fast North Running Club',
    age: 28,
  },
  raceMap: undefined,
  result: {
    name: 'Casey Smith',
    chipTime: '1:00:00',
    overallPlace: '1st',
    raceStatus: RaceStatus.Complete,
    age: '28',
    ageGroup: 'M25-29',
    ageGroupGenderPlace: '1st',
    ageGroupPlace: '1st',
    bib: '127',
    division: 'Open',
    divisionPlace: '1st',
    finishTimeLocal: '10:30:00 AM',
    fromCity: 'Toronto',
    fromCountry: 'Canada',
    gender: 'Male',
    genderPlace: '1st',
    gunStartTime: '9:30:00 AM',
    gunTime: '1:00:30',
    netTime: '1:00:00',
    overallPace: '4:34/km',
    pace: '4:34/km',
    raceTime: '1:00:00',
    percentComplete: '100%',
    countSegmentResults: '1',
    distance: '21.1',
    distanceUnit: 'km',
    segments: [
      {
        segmentId: 'seg-1',
        time: '0:28:45',
        pace: '5:45/km',
        segmentPace: '5:45/km',
        segmentCumulativePace: '5:45/km',
        raceTime: '0:28:45',
        overallPlace: '1st',
        genderPlace: '1st',
        ageGroupPlace: '1st',
        ageGroupGenderPlace: '1st',
        splitTime: '0:28:45',
        distance: '5',
        distanceUnit: 'km',
      },
    ],
  },
  resultId: 0,
  segmentResults: [
    {
      segmentResultUuid: 'seg-result-1',
      icon: '',
      label: 'Split 1',
      segmentTypeLabel: 'Split',
      distance: '5 km',
      show: null,
    },
  ],
  stats: {
    primary: [{ value: '1:00:00' }],
    ranking: [
      {
        label: 'of 20',
        hasLock: false,
        addendum: 'of 20',
        icon: 'trophy',
        value: '1st Overall',
      },
      {
        label: 'of 16',
        hasLock: false,
        addendum: 'of 16',
        icon: '',
        value: '1st Male',
      },
      {
        label: 'of 8',
        hasLock: false,
        addendum: 'of 8',
        icon: '',
        value: '1st M2530',
      },
    ],
  },
  subEventId: 0,
  uniqueCode: '',
};

export const DEFAULT_SUB_EVENT: FullSubEvent = {
  createdDate: new Date(),
  description: '',
  name: 'Demo Half Marathon',
  eid: 0,
  eventUniqueCode: '',
  hasResults: false,
  isPublic: false,
  lastModifiedDate: new Date(),
  resultCount: 0,
  resultEventId: 0,
  resultSubEventId: 0,
  resultsType: ResultType.STRUCTURED,
  seid: 0,
  subEventDate: new Date(),
  segments: [SAMPLE_SEGMENT],
  columns: [
    {
      type: 'segment',
      segmentId: 'seg-1',
      col: 'split_1',
      label: 'Split 1',
    },
  ] as FullSubEvent['columns'],
};

export const DEFAULT_FINISHER_CERTIFICATE: FinisherCertificate = {
  applyToAllSubEvents: false,
  areSponsorLogosEnabled: false,
  bodyBackground: '',
  bodyText: '',
  border: '',
  createdAt: new Date(),
  headerBackground: '',
  headerText: '',
  id: '',
  isAdvancedCustomizationEnabled: false,
  isEventDateVisible: false,
  isEventLogoVisible: false,
  isEventNameVisible: false,
  isHidden: false,
  isPlaceVisibleBeforeRaceEnded: false,
  isProviderLogoVisible: false,
  lastModifiedAt: new Date(),
  resultEventId: 0,
  sponsorLogoHeight: 0,
  subEvents: {},
  useBackgroundImage: false,
};
